var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M14 5.833H8.167V0H5.833v5.833H0v2.334h5.833V14h2.334V8.167H14V5.833z","fill":"#4C4541"}})])}
var staticRenderFns = []

export { render, staticRenderFns }